import React from "react";
import { ExportAudienceDialogProps } from "./ExportAudience.types";
import { otherColumns, defaultColumns } from "./ExportAudience.helpers";

export function useExportAudience(props: ExportAudienceDialogProps) {
  const { onClose, onSuccess, customAttributeNames = [] } = props;

  const allOtherColumns = React.useMemo(
    () => [...otherColumns, ...customAttributeNames],
    [customAttributeNames]
  );

  const [selected, setSelected] = React.useState<string[]>([]);

  const isSelected = (column: string) => selected.includes(column);

  const selectAll = (checked: boolean) => {
    setSelected(checked ? allOtherColumns : []);
  };

  const selectColumn = (column: string, checked: boolean) => {
    setSelected((prev) =>
      checked ? [...prev, column] : prev.filter((i) => i !== column)
    );
  };

  const allChecked =
    allOtherColumns.length > 0 && allOtherColumns.length === selected.length;

  return {
    onClose,
    onSuccess,
    defaultColumns,
    allChecked,
    isSelected,
    selected,
    selectAll,
    allOtherColumns,
    selectColumn,
    customAttributeNames,
  };
}
